<template>
    <div class="addSysMsg">
        <el-form ref="form" :model="messageData.instance" label-width="120px">
            <div class="choseUserCon el-form-item">
                <!-- <el-input @focus="chose"></el-input> -->
                <!-- <el-button
                    type="primary"
                    @click="chose"
                    class="el_right chose-btn"
                    size="small"
                >
                    选择人员
                </el-button> -->
                <label class="el-form-item__label" @click="chose"><a href="javascript:;">选择人员</a></label>
                <ul class="selectedUsers el-form-item__content">
                    <li v-for="item in messageData.receivers" :key="item.userid">
                        <span>{{ item.username }}</span>
                        <a @click="delUser(item)">×</a>
                    </li>
                </ul>
            </div>
            <el-form-item label="消息标题">
                <el-input v-model="messageData.instance.title"></el-input>
            </el-form-item>
            <el-form-item label="消息内容" class="editor">
                <!-- v-model="messageData.instance.content" -->
                <wangEditor
                    :is-clear="isClear"
                    @change="editorChange"
                    :guid="guid"
                ></wangEditor>
            </el-form-item>
            <el-form-item label="附件">
                <el-button title="附件上传">
                    <el-upload
                        class="uploadfile"
                        action=""
                        :http-request="uploadFileMethod"
                        :show-file-list="false"
                        multiple
                    >
                        <span>附件上传</span>
                    </el-upload>
                </el-button>
            </el-form-item>
            <el-form-item label="" v-if="fileList.length>0" class="uploadListCon">
                <ul class="uploadList">
                    <li v-for="item in fileList" :key="item.uid">
                        <span class="iconfont iconwenjian"></span>
                        <span>{{ item.name }}</span>
                    </li>
                </ul>
            </el-form-item>
            <!-- <el-form-item>
                <el-button type="primary" @click="onSubmit">
                    发布
                </el-button>
                <el-button @click="close">
                    取消
                </el-button>
            </el-form-item> -->
        </el-form>
        <div class="btn-con">
            <el-button @click="close" size="small">
                取消
            </el-button>
            <el-button type="primary" size="small" @click="onSubmit">
                发布
            </el-button>
        </div>
        <choseMembers
            :show-dialogue="choseMemberD.show"
            :type="choseMemberD.type"
            :dialogue-tit="choseMemberD.tit"
            @update-show="updateShowDialogue"
            @sure-members="sureMembers"
            :chosed-members="messageData.receivers"
        ></choseMembers>
    </div>
</template>
<script>
import wangEditor from './wangEditor';
import choseMembers from './sysChoseMembers';
import utils from '@/utils/util';
export default {
    components: { wangEditor, choseMembers },
    props: {},
    data() {
        return {
            form: {
            },
            choseMemberD: {
                show: false,
                type: '',
                tit: '选取人员',
            },
            messageData: {
                instance: {
                    type: 1,
                    content: '',
                },
                receivers: [],
                events: [],
                enclosures: [],
            },
            isClear: false,
            guid: '',
            fileList: [],
        };
    },
    computed: {},
    methods: {
        close() {
            this.$parent.$emit('close');
        },
        chose() {
            this.choseMemberD.show = true;
        },
        updateShowDialogue(val) {
            this.choseMemberD.show = val;
        },
        editorChange(val) {
            this.messageData.instance.content = val;
        },
        onSubmit() {
            this.addMessage();
        },
        // 选取人员完成后回调
        sureMembers(data) {
            const rows = data.data.map(v => {
                return {
                    userid: v.user_id,
                    username: v.user_name,
                };
            });
            this.messageData.receivers = this.messageData.receivers.concat(rows);
        },
        // 删除选取的人员
        delUser(data) {
            const arr = this.messageData.receivers;
            arr.splice(arr.findIndex(item => item.userid === data.userid), 1);
            this.messageData.receivers = arr;
        },
        // 发布系统消息接口
        addMessage() {
            this.$axios
                .post('/interfaceApi/message/MessageInfo/add_message', this.messageData)
                .then(res => {
                    this.$message.success(res);
                    this.$parent.$emit('close');
                }).catch(error => {
                    this.$message.error(error.message);
                });
        },
        // 上传附件（普通上传）
        uploadFileMethod(param) {
            const fileStage = param.file;
            const tenantId = this.$takeTokenParameters('TenantId');
            const formData = new FormData();
            formData.append('FileType', 0);
            formData.append('BusinessTypeCode', 'SystemMessage');
            formData.append('DataId', this.guid);
            formData.append('DirectoryId', '');
            formData.append('TenantId', tenantId);
            formData.append('File', param.file);
            this.$axios
                .post(`${this.FILE.FILE_BASE_URL()}file-manage?__tenant=${tenantId}`, formData)
                .then(res => {
                    if (res) {
                        this.fileList.push(fileStage);
                        this.messageData.enclosures.push({ filename: fileStage.name, filesize: fileStage.size, keyid: res.Id });
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                });
        },
    },
    created() {
        this.guid = utils.getGuid();
    },
    mounted() {},
};
</script>
<style lang="stylus">
.addSysMsg
    height 100%
    overflow hidden
    .el-form
        width 100%
        height calc(100% - 50px)
        overflow-y auto
        overflow-x hidden
        .el-form-item__label
            width 120px!important
    .el-form-item__label
        line-height 40px
    .el-button
        padding 8px 20px
        font-size 14px
    .btn-con
        text-align center
        position absolute
        bottom 20px
        width 100%
    .el-form-item__content
        line-height 36px
        height 36px
    .el-tree-node__content
        height 30px
    .el-form-item__content
        width: calc(100% - 135px);
        margin-left: 120px!important;
    .editor
        margin-bottom 22px
        .el-form-item__content
            line-height auto
            height auto
    .uploadListCon
        height 100px
        overflow-y auto
        overflow-x hidden
        .uploadList
            display inline-block
            width calc(100% - 20px)
            li
                font-size 15px
                .iconfont
                    font-size 16px
                    color #1296db
                    margin-right 10px
                    line-height 16px
                border-bottom 1px solid #eee
    .choseUserCon
        position relative
        .chose-btn
            width: 80px;
            text-align: center;
            padding 0
            height 36px
            line-height 32px
        .el-form-item__label
            a
                color #1577D2
                text-decoration underline
        .el-form-item__content
            min-height 36px
            height auto
        .selectedUsers
            background #fff
            z-index 10
            border 1px solid #DCDFE6
            height 100%
            overflow-y auto
            box-shadow 0 0 1px
            border-radius: 2px;
            padding 10px
            min-height 36px
            max-height 160px
            li
                float left
                list-style none
                border-width 1px
                border-style solid
                border-color rgb(202, 216, 243)
                // border-image initial
                border-radius 6px
                font 16px/28px '微软雅黑'
                padding 0 8px
                background rgb(222, 231, 248)
                margin 1px 5px 0 0
                height 30px
                line-height 26px
                margin-bottom 10px
                a
                    margin-left 5px
                    font-size 20px
                    color #777
                    cursor pointer
                &:hover
                    a
                        color #f56c6c
</style>